import React, {useState,useEffect} from 'react'
import styled from 'styled-components';
import { Link } from 'react-router-dom'
import ImageError from '../error/error';
import { url } from '../../App';
import Skeleton from '../skeleton/skeleton';

const Wrapp = styled(Link)`
text-decoration:none;
width:100%;

/* margin-right:30px; */
`
const Img = styled.img`
width:100%;
margin-right:30px;
/* box-shadow: 30px 30px 0  #F9A826; */
border:2px solid #F9A826;
    &:hover{
        transform: scale(1.1);
        transition:.5s;
    }
@media screen and (max-width: 768px){
    margin-bottom:80px;
}
@media screen and (max-width: 1100px){
    margin-right:80px;
    margin-bottom:80px;
}
`
const handleclick = ()  => {
    console.log("ok")
}
function Certificates(){
    const [ data, setData ] = useState([]);
    const [loading,setLoading] = useState(false);
    const [ error, setError] = useState(false)

    async function getCertificate(){
        setLoading(true)
        try{
            let res = await fetch(`${url}/get-certificate`)
            let data = await res.json()
            setData(data.data)
        } catch(error){
            setError(true)
        } finally{
            setLoading(false)
        }
    }
    useEffect(() => {
     getCertificate()
    },[])
   
    if(error){
        return(
            <ImageError />
        )
    }
    if(loading){
        return(
            <Skeleton width={"300px"} height={"320px"} amount={3} />
        )
    }
    return(
        <>
            {
               data.map(item=> {
                    return(
                        <Wrapp to={'certificates/' + item.id} key={item.id}>
                                <Img  src={item.image} alt="certificates" />
                        </Wrapp>
                    )
                })
            
            }
        </>
    )
}
export default Certificates;